import React, { Component } from "react";
import ReadAxios from "../axiosComponent/read";
import MiniPlaceholder from "./miniPlaceHolder";
import { translate } from "react-i18next";
import isEmpty from "lodash/isEmpty";

export class VehicleType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicleType: [],
    };
  }

  async componentDidMount() {
    console.log(this.props.proposedVehicleType);
    let dataArray =
      (await ReadAxios({
        url: `vehicleTypeMaster/${this.props.proposedVehicleType}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ vehicleType: dataArray || [] });
    console.log(this.state.vehicleType);
  }

  render() {
    const { t } = this.props;
    const { vehicleType } = this.state;

    return (
      <>
        {/* <label className="w3-text-blue bfonter">
          {t("list_view.movement_type") || "Movement Type"} : &nbsp; 
          <span className="p-bold-600 movement_type">{ this.props.movementType }</span>
        </label> */}
        {/* <div>
          <span
            className="sumo_truck_quantity"
            style={{
              width: "55px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          > */}
            <span>{vehicleType.length > 0 ? vehicleType[0].vehicleType : "NA"}</span>
          {/* </span>
          <img src="assets/svg/sumo_truck.svg" alt="sumo_truck" width="60%" />
        </div> */}
      </>
    ) 
    // : (
    //   <MiniPlaceholder />
    // );
  }
}

export default translate("shipment")(VehicleType);
